// Because common package does not depend on any other package including db, we have to copy the permission roles here.
// Remember to keep it updated with DB.
export var EnumForCommonOnlyPermissionRole;
(function (EnumForCommonOnlyPermissionRole) {
    EnumForCommonOnlyPermissionRole["ADMIN"] = "ADMIN";
    EnumForCommonOnlyPermissionRole["ROOT_ADMIN"] = "ROOT_ADMIN";
    EnumForCommonOnlyPermissionRole["CROSSWORD_READ"] = "CROSSWORD_READ";
    EnumForCommonOnlyPermissionRole["CROSSWORD_WRITE"] = "CROSSWORD_WRITE";
    EnumForCommonOnlyPermissionRole["USER_READ"] = "USER_READ";
    EnumForCommonOnlyPermissionRole["USER_WRITE"] = "USER_WRITE";
    EnumForCommonOnlyPermissionRole["SHOW_READ"] = "SHOW_READ";
    EnumForCommonOnlyPermissionRole["SHOW_WRITE"] = "SHOW_WRITE";
    EnumForCommonOnlyPermissionRole["UPLOAD_READ"] = "UPLOAD_READ";
    EnumForCommonOnlyPermissionRole["UPLOAD_WRITE"] = "UPLOAD_WRITE";
    EnumForCommonOnlyPermissionRole["CONSOLE_ACCESS"] = "CONSOLE_ACCESS";
    EnumForCommonOnlyPermissionRole["PURCHASE_READ"] = "PURCHASE_READ";
    EnumForCommonOnlyPermissionRole["PURCHASE_WRITE"] = "PURCHASE_WRITE";
    EnumForCommonOnlyPermissionRole["CREDIT_VOUCHER_READ"] = "CREDIT_VOUCHER_READ";
    EnumForCommonOnlyPermissionRole["CREDIT_VOUCHER_WRITE"] = "CREDIT_VOUCHER_WRITE";
})(EnumForCommonOnlyPermissionRole || (EnumForCommonOnlyPermissionRole = {}));
//# sourceMappingURL=index.js.map